export const CUSTOM_DATE_FORMATS = {
    parse: {
      dateInput: 'DD-MM-YYYY',
    },
    display: {
      dateInput: 'MMM DD, YYYY',
      monthLabel: {
        month: 'long'
      },
      monthYearLabel: {
        year: 'numeric'
      }
    },
}; 